<script setup lang="ts">
import katex from "@vscode/markdown-it-katex";
import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import json from "highlight.js/lib/languages/json";
import plaintext from "highlight.js/lib/languages/plaintext";
import python from "highlight.js/lib/languages/python";
import sql from "highlight.js/lib/languages/sql";
import xml from "highlight.js/lib/languages/xml";
import "katex/dist/katex.min.css";
import MarkdownIt from "markdown-it";
import { full as emoji } from "markdown-it-emoji";
import highlightjs from "markdown-it-highlightjs/core";
import sub from "markdown-it-sub";
import sup from "markdown-it-sup";
import { computed } from "vue";

import { isString } from "@/services/utils";

const { source, useHighlight = true } = defineProps<{ source: any; useHighlight?: boolean }>();
const renderer = MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
})
  .use(emoji)
  .use(sub)
  .use(sup)
  .use(katex);
if (useHighlight) {
  hljs.registerLanguage("json", json);
  hljs.registerLanguage("plaintext", plaintext);
  hljs.registerLanguage("python", python);
  hljs.registerLanguage("sql", sql);
  hljs.registerLanguage("xml", xml);
  hljs.registerLanguage("bash", bash);
  renderer.use(highlightjs, { inline: true, hljs });
}

const html = computed(() => {
  let s = source;
  if (!isString(s)) {
    s = JSON.stringify(s, null, 2);
    s = "```json\n" + s + "\n```";
  }
  return renderer.render(s);
});
</script>

<template>
  <div class="markdown" v-html="html"></div>
</template>

<style scoped>
:deep(.katex) {
  white-space: pre;
}
</style>
